module.exports = __webpack_public_path__ + "static/media/Y15.ec6b480c.mp3";